module.exports = __webpack_public_path__ + "static/media/cloud-d3-v3.de5fa9dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cloud-d3-v3.svg
// module id = 104
// module chunks = 0